import Request from "@/request/base"
import configBaseUrl from "@/config/baseUrl"

/**
 * @description 级联云
 * @author liupl
 * @date 2021-07-21
 * @export
 * @class CasBaseRequest
 * @extends {Request}
 */
export default class CasBaseRequest extends Request {
  constructor({ env }) {
    const baseURL = configBaseUrl[env].VUE_APP_APICASBASEURL
    super({
      baseURL
    })
  }
}
